export const ItemsFilter = {
    NONE : 'NONE',
    MENS_ITEM: 'MENS_ITEM',
    WOMAN_ITEMS: 'WOMAN_ITEMS',
    KIDS_ITEMS: 'KIDS_ITEMS',
}

export const FILTER_BRAND = {
    FILTER_BRAND : 'FILTER_BRAND'
}


// export const FILTER_BRAND = {
//     FILTER_ADD : 'FILTER_ADD',
//     FILTER_REMOVE : 'FILTER_REMOVE'
// }
